// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --survey-border-color: #DFE1E7;
    --survey-validation-error-color: #CE2C32;
    --survey-placeholder-color: #8E90A6;
    --default-primary-color: #5381c3;

    /* MDHUI design system variables (light scheme defaults)
       Sourced from MyDataHelpsUI/src/helpers/globalCss.ts
       These allow survey components to share tokens with the MDHUI component library. */
    --mdhui-background-color-0: #fff;
    --mdhui-border-color-2: #bbb;
    --mdhui-text-color-0: #000;
    --mdhui-text-color-2: #555;
    --mdhui-card-border-radius: 12px;
    --mdhui-modal-overlay-color: rgba(130, 130, 130, 0.5);
    --mdhui-padding-xs: 8px;
    --mdhui-padding-md: 16px;
    --mdhui-padding-lg: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/SurveyVars.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,mCAAmC;IACnC,gCAAgC;;IAEhC;;wFAEoF;IACpF,gCAAgC;IAChC,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,gCAAgC;IAChC,qDAAqD;IACrD,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;AAC5B","sourcesContent":[":root {\n    --survey-border-color: #DFE1E7;\n    --survey-validation-error-color: #CE2C32;\n    --survey-placeholder-color: #8E90A6;\n    --default-primary-color: #5381c3;\n\n    /* MDHUI design system variables (light scheme defaults)\n       Sourced from MyDataHelpsUI/src/helpers/globalCss.ts\n       These allow survey components to share tokens with the MDHUI component library. */\n    --mdhui-background-color-0: #fff;\n    --mdhui-border-color-2: #bbb;\n    --mdhui-text-color-0: #000;\n    --mdhui-text-color-2: #555;\n    --mdhui-card-border-radius: 12px;\n    --mdhui-modal-overlay-color: rgba(130, 130, 130, 0.5);\n    --mdhui-padding-xs: 8px;\n    --mdhui-padding-md: 16px;\n    --mdhui-padding-lg: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
